import * as React from 'react'
import i18next from 'i18next'
import { Button, Form, Alert } from 'react-bootstrap'

import { updateFormData, tryLogin } from 'src/store/login'
import { Trans } from 'react-i18next'

const { t } = i18next

class LoginVariant extends React.Component {
  handleKeyDown = event => {
    if (event.key === 'Enter') {
      this.handleSubmitLogin()
    }
  }

  handleChange = ({ target }) => {
    let { name, value } = target
    if (name === 'username' && value) {
      value = value.toLowerCase().trim()
    }
    this.props.dispatch(updateFormData({ name, value }))
  }

  handleSubmitLogin = async () => {
    let { username, password } = this.props.loginData
    await this.props.dispatch(tryLogin({ username, password, tenant: this.props.tenant }))
  }

  render() {
    let { maintenanceMode, loginData } = this.props
    let { message_type, message, username, password, loading } = loginData

    return (
      <div className="card-body p-3 pt-2">
        <div className="mb-2">
          <h4 className="mb-3 text-center">
            <Trans i18nKey="system_wide.login_form.login_reserved_area">Accedi alla tua area riservata</Trans>
          </h4>
        </div>
        <Alert variant={message_type} show={message !== ''} onClose={this.resetMessage} transition={false}>
          {message}
        </Alert>
        <Form className="mb-2" onKeyDown={this.handleKeyDown} noValidate>
          <Form.Group className="mb-3">
            <Form.Label>
              <Trans i18nKey="system_wide.login_form.username_or_email">Username o email</Trans>
            </Form.Label>
            <Form.Control
              className="text-lowercase"
              name="username"
              placeholder="username"
              value={username}
              onChange={this.handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              <Trans i18nKey="system_wide.login_form.password">Password</Trans>
            </Form.Label>
            <Form.Control
              type="password"
              name="password"
              placeholder={t('system_wide.login_form.password', 'Password')}
              value={password}
              onChange={this.handleChange}
            />
          </Form.Group>

          <div className="mt-3 text-center">
            <Button
              style={{ minWidth: '6rem' }}
              color="primary"
              size="md"
              disabled={username === '' || password === '' || loading === true}
              onClick={this.handleSubmitLogin}>
              {loading === true && (
                <>
                  <span className="spinner-border spinner-border-sm"></span>
                  <Trans i18nKey="buttons.login">Login</Trans>
                </>
              )}
              {loading === false && <Trans i18nKey="buttons.login">Login</Trans>}
            </Button>
            {/* <PoweredBy /> */}
          </div>
        </Form>
        {maintenanceMode === false && (
          <button className="link-button" onClick={this.props.handleForgotPassword}>
            <Trans i18nKey="buttons.forgotten_password">Password dimenticata</Trans>
          </button>
        )}
      </div>
    )
  }
}

export default LoginVariant
